import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHead, Carousel, PlaceCard, Skeleton } from '../ui';
import { fetchFeaturedTemples } from '../../services/templeService';
import { FALLBACK_PLACES } from '../../data/home';

const firstHours = (oh) => (oh && (oh.monday || Object.values(oh)[0])) || 'Open daily';
const LOCAL_BY_NAME = [
  [/ram|janmabhoomi/i, '/images/design/hero-ram-mandir.webp'],
  [/hanuman/i, '/images/hanuman/temple-1.webp'],
  [/kanak/i, '/images/kanak-bhawan/temple.jpg'],
  [/nageshwar|naya/i, '/images/ghats/naya-ghat-1.jpg'],
  [/saryu|sarayu/i, '/images/ghats/saryu-ghat-1.jpeg'],
  [/guptar/i, '/images/ghats/guptar-ghat/1.jpg'],
];
const localImage = (name = '') => (LOCAL_BY_NAME.find(([re]) => re.test(name)) || [null, '/images/design/ram-mandir-complex.webp'])[1];

export default function SacredPlaces() {
  const { t } = useTranslation();
  const [places, setPlaces] = useState(null);

  useEffect(() => {
    let alive = true;
    const timer = setTimeout(() => { if (alive) setPlaces((p) => p ?? FALLBACK_PLACES); }, 4000);
    fetchFeaturedTemples(6)
      .then((res) => {
        if (!alive) return;
        const list = Array.isArray(res) ? res : res?.data || [];
        if (!list.length) { setPlaces(FALLBACK_PLACES); return; }
        setPlaces(list.map((x) => ({
          title: x.name,
          subtitle: x.significance || x.description || '',
          image: x.images?.[0] || localImage(x.name),
          to: x.slug ? `/temples/${x.slug}` : '/temples',
          meta: [{ icon: 'clock', text: firstHours(x.openingHours) }],
        })));
      })
      .catch(() => { if (alive) setPlaces(FALLBACK_PLACES); })
      .finally(() => clearTimeout(timer));
    return () => { alive = false; clearTimeout(timer); };
  }, []);

  return (
    <div className="sacred">
      <SectionHead eyebrow={t('Discover Ayodhya')} title={t('Sacred Places & Experiences')} action={{ label: t('View All'), to: '/temples' }} />
      {places ? (
        <Carousel ariaLabel={t('Sacred places')} itemWidth={248} gap={16}>
          {places.map((p) => <PlaceCard key={p.title} {...p} title={t(p.title)} subtitle={t(p.subtitle)} meta={(p.meta || []).map((m) => ({ ...m, text: t(m.text) }))} cta={t('Explore')} />)}
        </Carousel>
      ) : (
        <div className="card-grid">
          {[0, 1, 2, 3].map((i) => <Skeleton key={i} height={300} radius="var(--r-lg)" />)}
        </div>
      )}
    </div>
  );
}
